<template>
  <div class='describe'>
    <div class="container">
      <!-- <ul class="heads" :style="{'marginLeft':actives==0?'0':'27px'}"> -->
      <ul class="heads">
        <li v-for="(item,index) in list" :key="index" :class="{'actvie':actives==index}">
          <a href="javascript:void(0);" @click="toggle(index)">{{item.name}}</a>
          <i class="el-icon-arrow-down"></i>
        </li>
      </ul>
      <design v-if="actives==0" />
      <ParticipationInstructions v-if="actives==1" />
      <Iwanttocompete v-if="actives==2" />
      <competitionrules v-if="actives==3" />
      <prizesettings v-if="actives==4" />
      <Download v-if="actives==5" />
      <groupmeeting v-if="actives==6" />
      <login v-if="activeIndex2==7&&actives===null"/>
      <Registeraccount v-if="activeIndex2==8&&actives===null"></Registeraccount>
      <check-password v-if="activeIndex2==9&&actives===null"></check-password>
      <Download v-if="activeIndex2==10&&actives===null" />
      <Auditdetails v-if="activeIndex2==11&&actives===null" ></Auditdetails>
    </div>
  </div>
</template>

<script>
import competitionrules from "./competitionrules.vue"
import design from "./design.vue"
import ParticipationInstructions from "./ParticipationInstructions.vue"
import prizesettings from "./prizesettings.vue"
import groupmeeting from "./groupmeeting.vue"
import Iwanttocompete from "./Iwanttocompete.vue"
import Download from "./Download.vue"
import login from "./Login.vue"
import Registeraccount from "./Registeraccount.vue"
import Auditdetails from "./Auditdetails.vue"
import checkPassword from '@/views/changePassword.vue'
import {mapState,mapMutations} from 'vuex'
export default {
  data(){
    return {
 
    }
  },
  components:{
    competitionrules,
    design,
    ParticipationInstructions,
    prizesettings,
    groupmeeting,
    Iwanttocompete,
    Download,
    login,
    Registeraccount,
    Auditdetails,
    checkPassword
  },
  watch:{
    lang(newVal){

    }
  },
  computed:{
    list(){
      // var i = this.list.findIndex((item)=>item.ischecked)
      var arr =  [
        {
          name:this.$t('Introduction'),
          ischecked:true
        },
        {
          name:this.$t('EntryInformation'),
          ischecked:false
        },
        {
          name:this.$t('Participation'),
          ischecked:false
        },
        {
          name:this.$t('Scopeofentriessubmitted'),
          ischecked:false
        },
        {
          name:this.$t('Awardssetting'),
          ischecked:false
        },
        {
          name:this.$t('DocumentDownload'),
          ischecked:false
        },
        {
          name:this.$t('Contactthetheorganizingcommittee'),
          ischecked:false
        }
      ] 
      console.log('this.curIndex',this.curIndex);
      if(this.curIndex>=0){
        arr[this.curIndex].ischecked=true 
      }
      return arr
      
      
    }
  },
  methods:{
    ...mapMutations(['SETACTIVES']),
    toggle(i){
      if(this.curIndex==i){
        this.curIndex = -1
      }else{
        this.curIndex = i
      }
      // this.SETACTIVES(i)
      // this.actives = i
      
      if(this.list[i].ischecked==false||this.actives!=i){
        this.list.map(v=>{
          v.ischecked  =false
        })
        this.list[i].ischecked = true
        this.SETACTIVES(i)
      }else{
        // this.actives = null
        this.SETACTIVES(null)
        this.list[i].ischecked = false
      }
    }
  }
}
</script>

<style lang="less">
  
  .describe{
    .heads{
      margin-top: 45px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // margin-left:27px;
      // margin-right: 24px;
      min-height: 41px;
      margin-bottom: 35px;
      li{
        
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        i{
          position: absolute;
          bottom: 1px;
          color:#FFFFFF;
          opacity: 0;
        }
        a{
          color:#6F73F4;
          height: 33px;
          font-size: 20px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          text-decoration-line:none;
        }
      }
      .actvie{
        // width: 184px;
        padding: 0 20px;
        // height: 80px;
        background: linear-gradient(24deg, #797DFF 0%, #C29AF0 100%);
        box-shadow: 0px 3px 0px 1px #897CE2;
        border-radius: 50px 50px 50px 50px;
        i{
          opacity: 1 !important;
        }
          a{
          color: #fff;
          }
      }
    }
  }
  @media (min-width: 1200px){
    .container {
    width: 1200px !important;
    padding: 0 60px!important;
}
  } 

  @media screen and (max-width:993px) {
    .describe .heads{
      margin-top: 113px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // margin-left:27px;
      // margin-right: 24px;
      min-height: 80px;
      margin-bottom: 74px;
    }
    .actvie{width: 170px;}
    .describe .heads li{
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width:420px) {
    .rules .download .left .title{
      width: 268px;
      height: auto !important;
      overflow: hidden; 
      text-overflow: ellipsis; 
      display: -webkit-box;
      -webkit-line-clamp: 2; 
      -webkit-box-orient: vertical;
    }
  }

  @media screen and (max-width:1000px) {
    .from-data{
      margin-left:0 !important;
    }

    .headtitles{
      margin-left:0 !important;
    }
  }
</style>